import { GameData, Timing, CostProductionFormulas } from '../game-data.js';
import ResourceVector from "../resource-vector.js";

export default class BuildingCostFormulas {

    // Is the maximum allowed level reached
    static isLevelAvailable(building, building_limits, next_level) {
        return next_level <= building_limits[building.id];
    }

    // Most buildings require other buildings to be built
    static hasRequirements(building, planet_buildings) {
        let requirements = building.requirements;
        if (!requirements) {
            return false;
        }

        for (let i = 0; i < requirements.length; i++) {
            let requirement = requirements[i];
            if (planet_buildings[requirement.id] < requirement.level) {
                return false;
            }
        }

        return true;
    }

    static isVisibleToPlayer(building, gps) {
        return gps.building_visible[building.id];
    }

    static getCostTotal(building, building_level) {
        let scale_factor = CostProductionFormulas.getScaleFactor(building_level, 10, building.cost_level_offset);
        if (building_level <= 8) {
            scale_factor /= 4 - (building_level / 2 - 1);
        }
        const result = new ResourceVector().init().initSparse(building.cost());
        result.scaleVector(scale_factor / result.sumUpVector());
        return result.floor();
    }

    // Starts at 1, the game builds level 24 when you upgrade a building at level 23
    // -> When the building is 23 the input parameter (`building_level`) should be 24
    static getCostForUpgrade(building, building_level) {
        if (building_level === 1) {
            return BuildingCostFormulas.getCostTotal(building, building_level);
        }

        const previous = BuildingCostFormulas.getCostTotal(building, building_level - 1);
        const current = BuildingCostFormulas.getCostTotal(building, building_level);
        current.worker -= previous.worker;
        return current;
    }

    // See description of getCost
    static getTime(building, building_level, central_level) {
        // A factor to scale the standard build time with
        let time_factor = building.time();

        // For some buildings (research) level 3 is as expensive as standard building on level 5.
        if (building.time_level_offset) {
            building_level += building.time_level_offset();
        }

        // Calculate the time
        let time = Timing.planet_getBuildingTimeForLevel(building_level);
        time *= time_factor;
        time *= Timing.planet_getPlanetCenterSpeedUp(building_level, central_level);
        time *= GameData.HOUR;
        time /= GameData.SPEED;
        return Math.ceil(time);
    }

    // See description of getCost
    static getEnergyCost(building, building_level) {
        if (building_level <= 0) {
            return 0;
        }
        const scale_factor = CostProductionFormulas.getScaleFactor(building_level, 1 / 10, building.cost_level_offset);
        return Math.ceil(building.energy * scale_factor);
    }

    static getEnergyCostForUpgrade(building, building_level) {
        return BuildingCostFormulas.getEnergyCost(building, building_level) - BuildingCostFormulas.getEnergyCost(building, building_level - 1);
    }
}